/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineEpics } from 'redux-observable';
import { availabilityEpic } from '../src/epics/availability';

export const rootEpic = combineEpics(availabilityEpic);
